export default "__VITE_ASSET__Dqj3kns2__"